// API service for company data
import { API_BASE_URL } from '../config/api.config';
export interface CompanyMetrics {
  workLifeBalance: number;
  careerOpportunities: number;
  compensationBenefits: number;
  seniorManagement: number;
  cultureValues: number;
}

export interface Company {
  id: string;
  name: string;
  coordinates: [number, number];
  rating: number;
  avgSalary: number;
  totalJobs: number;
  hasLayoffs: boolean;
  layoffPercentage?: number;
  growthRate: number;
  industry: string;
  size: string;
  foundedYear: number;
  employeeCount: number;
  metrics: CompanyMetrics;
  logo?: string;
  description?: string;
  techStack?: string[];
  benefits?: string[];
}

export interface CompanyResponse {
  companies: Company[];
  count: number;
  bounds: {
    north: number;
    south: number;
    east: number;
    west: number;
  };
  zoom: number;
}

class CompanyApiService {
  private baseUrl: string;
  
  constructor() {
    this.baseUrl = API_BASE_URL;
  }
  
  async getCompaniesInViewport(
    bounds: { north: number; south: number; east: number; west: number },
    zoom: number
  ): Promise<CompanyResponse> {
    const params = new URLSearchParams({
      north: bounds.north.toString(),
      south: bounds.south.toString(),
      east: bounds.east.toString(),
      west: bounds.west.toString(),
      zoom: zoom.toString()
    });
    
    const response = await fetch(`${this.baseUrl}/api/companies/viewport?${params}`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch companies: ${response.statusText}`);
    }
    
    return await response.json();
  }
  
  async getCompanyDetails(id: string): Promise<any> {
    const response = await fetch(`${this.baseUrl}/api/companies/${id}`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch company details: ${response.statusText}`);
    }
    
    return await response.json();
  }
}

export const companyApi = new CompanyApiService();
export default companyApi;